import React, {useState, useEffect} from 'react';
import CustomSnackbar from '../Components/CustomSnackbar';
import { Snackbar } from '@mui/material';
import { WriteProblemCableLocation } from '../WriteData/WriteCantonCommunications';
import { loadingProblemTypeDataComponent } from '../LoadingData/LoadingDataComponents';
import { CONST_CANTON, CONST_HIGHWAY } from '../Constants/ConstantsOptics';

const ModalEditingProblemCable = ({ isEditing, setLinkEditingProblem, markerProblemLineCoordinates, setMarkerProblemLineCoordinates,
  lineId, user, handleEditingCancelClick, setLinkEditing, cantonCablaRefresh, mapRef, statusModalTerritory, highwayRefresh}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [problemTypeData, setProblemType] = useState([]); 
  const [selectedProblemType, setSelectedProblemType] = useState(null);
  const [textAreaValue, setTextAreaValue] = useState("");
  
  const map = mapRef.current;

   useEffect(() => {
      const fetchOwnerWellData = async () => {
        try {
          const data = await loadingProblemTypeDataComponent();
          setProblemType(data);
        } catch (error) {
        }
      };
      fetchOwnerWellData(); 
    }, []); 

  const saveEditingLine = async () => {
    if (window.currentMarker) {
      map.removeLayer(window.currentMarker);
      window.currentMarker = null;
    }
    if(statusModalTerritory === CONST_CANTON){
      WriteProblemCableLocation(markerProblemLineCoordinates, lineId, selectedProblemType, textAreaValue,  user, showSnackbar,
        setLinkEditing, setLinkEditingProblem, setTextAreaValue, setMarkerProblemLineCoordinates, cantonCablaRefresh);
    } else if(statusModalTerritory === CONST_HIGHWAY){
      WriteProblemCableLocation(markerProblemLineCoordinates, lineId, selectedProblemType, textAreaValue,  user, showSnackbar,
        setLinkEditing, setLinkEditingProblem, setTextAreaValue, setMarkerProblemLineCoordinates, highwayRefresh);
     } 
    } 

    if (isEditing) {
    return (
      <div className="divCurrentLengthCable">
         <label style={{ color: '#d1d1d1', fontSize: "16px" }}>Проблемные место</label>
         <hr className='horizontalLineDialog2'/>

         <label style={{ color: '#292929', fontWeight: 'bold'}}>Причина: </label>
        <select className="selectStyleDrawer" 

        onChange={(event) => setSelectedProblemType(event.target.value)} 
        >
           <option value="">пусто</option>
          {problemTypeData.map(problem => (
            <option key={problem.id} value={problem.id}>{problem.type}</option>
          ))}
        </select>
        <br/>
        <textarea
           className='textAreaEditingModal'
           value={textAreaValue}
           onChange={(event) => setTextAreaValue(event.target.value)} 
         />
        <br/>
        <button  class='buttonEditingLineSave'style={{marginRight: "5px"}} onClick={saveEditingLine} > Сохранить изменения</button>
        <button  class='buttonEditingLineСancel' onClick={handleEditingCancelClick}> Отмена</button>

      {/* Snackbar */}
      <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }         
        }}
      />       
      </div>
    );
    
  } else {
    return null;
  }  
}

export default ModalEditingProblemCable;